const OPACITY_THRESHOLD = 0.25;

export const calculateOpacitiesSearchMode = () => ({
  mainHeaderOpacity: 0,
  secondHeaderOpacity: 1,
});

export const calculateOpacities = (mainHeaderHeight, scrollY) => {
  let mainHeaderOpacity;
  let secondHeaderOpacity;

  const threshold = mainHeaderHeight * OPACITY_THRESHOLD;
  if (scrollY < threshold) {
    mainHeaderOpacity = 1;
    secondHeaderOpacity = 0;
  } else {
    const availableSpace = mainHeaderHeight - threshold;
    const scrollYInAvailableSpace = scrollY - threshold;
    const scrollYInPercentage = scrollYInAvailableSpace / availableSpace;

    mainHeaderOpacity = scrollYInPercentage > 1 ? 1 : 1 - scrollYInPercentage;

    secondHeaderOpacity =
      scrollY > mainHeaderHeight ? 1 : 1 - mainHeaderOpacity;
  }

  return {
    mainHeaderOpacity,
    secondHeaderOpacity,
  };
};
